import React from 'react';
import { Input, InputProps } from '@chakra-ui/react';

// A simple styled input component that applies our desired styles directly
export const StyledInput = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return (
    <Input
      ref={ref}
      bg="white"
      borderWidth="1px"
      borderColor="gray.300"
      borderRadius="md"
      color="gray.900"
      height="48px"
      px="1rem"
      fontSize="1rem"
      _focus={{
        borderColor: "blue.500",
        boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)"
      }}
      _placeholder={{ color: "gray.400" }}
      {...props}
    />
  );
});

StyledInput.displayName = 'StyledInput';

export default StyledInput;
